<template>
  <div class="px-5 py-1">
    <v-container grid-list-xl fluid>
      <h2 class="darkblue--text font-weight-700 fs-16 lh-16">
        BUDGET REPORT
      </h2>
      <v-breadcrumbs
        class="px-0 subtitle-2 mt-0 pt-0"
        :items="breadcrumbs"
      ></v-breadcrumbs>
      <v-card>
        <v-card-title class="primary pa-2 white--text">
          <span class="title pl-2">ADD NEW BUDGET</span>
        </v-card-title>

        <ValidationObserver ref="obs">
          <v-form @submit.prevent="confirmSubmit" id="formBudget">
            <v-card-text class="px-5 pt-5">
              <v-row>
                <v-col sm="12" class="text-center btn-tab-upload mb-5">
                  <span class="btn-tab-outer">
                    <v-btn
                      :text="singleBO === false"
                      depressed
                      color="primary"
                      class="text-capitalize btn-upload-io f-14"
                      @click="singleBO = true"
                    >
                      Upload Single BO
                    </v-btn>
                    <v-btn
                      :text="singleBO"
                      depressed
                      color="primary"
                      class="text-capitalize btn-add-manual f-14"
                      @click="singleBO = false"
                    >
                      Upload Multiple BO
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
              <template v-if="singleBO">
                <v-layout row wrap>
                  <v-flex xs4>
                    <!-- <ValidationProvider
                      name="Budget ID"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">Budget ID</label>
                      <v-text-field
                        id="budgetId"
                        single-line
                        outlined
                        label="Budget ID"
                        v-model="items.code"
                        required
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider> -->

                    <label class="darkblue--text">Created At</label>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :disabled="true"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          id="CreatedAt"
                          v-model="date"
                          label="Picker in menu"
                          prepend-inner-icon="event"
                          readonly
                          single-line
                          outlined
                          dense
                          v-on="on"
                          :disabled="true"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(date)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>

                    <ValidationProvider
                      name="Budget Name"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">Budget Name</label>
                      <v-text-field
                        id="nameBudget"
                        single-line
                        outlined
                        dense
                        label="Budget Name"
                        v-model="items.name"
                        required
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>

                    <ValidationProvider
                      name="House"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">House</label>
                      <v-autocomplete
                        id="houseId"
                        single-line
                        outlined
                        dense
                        label="Select House"
                        v-model="items.house"
                        required
                        :items="itemsHouse"
                        return-object
                        item-text="name"
                        :error-messages="errors"
                        :success="valid"
                        autocomplete="off"
                      ></v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider
                      name="Brand"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">Brand</label>
                      <v-autocomplete
                        id="brandId"
                        single-line
                        outlined
                        dense
                        label="Select Brand"
                        v-model="items.brand"
                        return-object
                        required
                        :items="itemsBrand"
                        item-text="name"
                        :error-messages="errors"
                        :success="valid"
                        autocomplete="off"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <label class="darkblue--text">Fiscal Month and Year</label>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :return-value.sync="fiscal"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          name="Fiscal"
                          rules="required"
                          v-slot="{ errors, valid }"
                        >
                          <v-text-field
                            id="fiscal"
                            v-model="fiscal"
                            type="month"
                            label="Picker in Menu"
                            prepend-inner-icon="event"
                            readonly
                            single-line
                            outlined
                            dense
                            v-on="on"
                            :error-messages="errors"
                            :success="valid"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        type="month"
                        v-model="fiscal"
                        no-title
                        scrollable
                        id="fiscalDate"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu2 = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu2.save(fiscal)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>

                    <ValidationProvider
                      name="Budget Owner"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">Budget Owner</label>
                      <v-autocomplete
                        id="ownerId"
                        single-line
                        outlined
                        dense
                        label="Select Budget Owner"
                        v-model="items.budget_owner"
                        required
                        :items="itemsOwner"
                        item-text="desc"
                        return-object
                        :error-messages="errors"
                        :success="valid"
                        autocomplete
                        @change="autoCompleteBudget()"
                      ></v-autocomplete>
                    </ValidationProvider>

                    <ValidationProvider
                      name="Entity"
                      rules="required"
                      v-slot="{ errors, valid }"
                    >
                      <label class="darkblue--text">Entity</label>
                      <v-autocomplete
                        id="entityId"
                        single-line
                        outlined
                        dense
                        label="Select Entity"
                        v-model="items.entity"
                        required
                        :items="itemsEntity"
                        return-object
                        item-text="name"
                        :error-messages="errors"
                        :success="valid"
                        autocomplete="off"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs4>
                    <label class="darkblue--text">Upload Budget</label>
                    <vue-dropzone
                      :use-font-awesome="true"
                      ref="myVueDropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      @vdropzone-complete="afterComplete"
                    ></vue-dropzone>

                    <v-btn
                      class="secondblue mt-3 white--text"
                      block
                      :disabled="isDisabled"
                      @click="parseFile('single')"
                      id="convertButton"
                      >Convert File to Table</v-btn
                    >

                    <v-btn
                      class="thirdblue mt-3 white--text"
                      block
                      @click="getTemplate('single')"
                      id="downloadButton"
                      >Download Template Budget</v-btn
                    >
                  </v-flex>
                </v-layout>
                <hr class="hr-line" style="" />
                <v-layout row wrap class="px-3" v-if="isVisible">
                  <span class="font-weight-medium subtitle-1 darkblue--text"
                    >Converted File
                  </span>
                  <span
                    class="body-2 font-weight-light secondblue--text pt-1 pl-2"
                    id="nameFile"
                  >
                    [[ {{ nameFile }} ]]</span
                  >
                  <v-col sm="12" class="px-0">
                    <template>
                      <v-simple-table
                        class="spending-table"
                        id="convertedTable"
                      >
                        <template v-slot:default>
                          <thead>
                            <tr class="primary">
                              <th
                                class="f-14 white--text text-center"
                                width="10%"
                              >
                                Taxonomy
                              </th>
                              <th
                                class="f-14 white--text text-center"
                                width="50%"
                              >
                                Taxo Protein Description
                              </th>
                              <th class="f-14 white--text text-center">
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <VuePerfectScrollbar
                            class="drawer-menu--scroll"
                            :settings="scrollSettings"
                          >
                            <tbody>
                              <tr
                                v-for="item in itemsConvert"
                                :key="item.amount"
                              >
                                <td class="f-14 black--text" width="10%">
                                  {{ item.taxonomy ? item.taxonomy : '-' }}
                                </td>
                                <td width="50%">
                                  {{ item.desc ? item.desc : '-' }}
                                </td>
                                <td class="text-right">
                                  {{ item.amount ? idr(item.amount) : '-' }}
                                </td>
                              </tr>
                            </tbody>
                          </VuePerfectScrollbar>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </v-layout>
              </template>
              <template v-else>
                <v-flex xs12>
                  <label class="darkblue--text">Upload Budget</label>
                  <vue-dropzone
                    :use-font-awesome="true"
                    ref="myVueDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    @vdropzone-complete="afterCompleteBulk"
                  ></vue-dropzone>

                  <v-btn
                    class="secondblue mt-3 white--text"
                    block
                    :disabled="isDisabledBulk"
                    @click="parseFile('multiple')"
                    id="convertButton"
                    >Convert File to Table</v-btn
                  >

                  <v-btn
                    class="thirdblue mt-3 white--text"
                    block
                    @click="getTemplate('multiple')"
                    id="downloadButton"
                    >Download Template Upload Multiple BO Budget</v-btn
                  >
                </v-flex>
                <hr class="hr-line" style="" />
                <v-layout row wrap class="px-3" v-if="isVisibleBulk">
                  <span class="font-weight-medium subtitle-1 darkblue--text"
                    >Converted File
                  </span>
                  <span
                    class="body-2 font-weight-light secondblue--text pt-1 pl-2"
                    id="nameFile"
                  >
                    [[ {{ nameFileBulk }} ]]</span
                  >
                  <v-col sm="12" class="px-0">
                    <template>
                      <!-- <table width="40%" class="darkblue--text my-2" v-if="itemsConvertBulk.data.length > 0">
                        <tr>
                          <td>
                            <span class="font-weight-bold">
                              Fiscal Month and Year <br />
                            </span>
                            {{ formatMonth(itemsConvertBulk.month) }} {{ itemsConvertBulk.year }}
                          </td>
                        </tr>
                      </table> -->
                      <v-simple-table
                        fixed-header
                        class="table-converted nav-table"
                        height="300px"
                        id="convertedTable"
                      >
                        <template v-slot:default>
                          <thead>
                            <tr class="primary">
                              <th class="f-14 white--text text-center">
                                Fiscal Month and Year
                              </th>
                              <th class="f-14 white--text text-center">
                                Budget Owner
                              </th>
                              <th class="f-14 white--text text-center">
                                Taxonomy
                              </th>
                              <th class="f-14 white--text text-center">
                                Taxo Protein Description
                              </th>
                              <th class="f-14 white--text text-center">
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(item, index) in itemsConvertBulk.data"
                            >
                              <tr class="bgTotal" :key="'budgetName' + index">
                                <td class="bgTotal" colspan="5">
                                  <b>{{ item.name }}</b>
                                </td>
                              </tr>
                              <tr
                                v-for="(budget, i) in item.detail"
                                :key="'budgetItem' + i"
                              >
                                <td class="f-12 black--text">
                                  {{
                                    itemsConvertBulk.month
                                      ? formatMonth(itemsConvertBulk.month)
                                      : '-'
                                  }}
                                  {{
                                    itemsConvertBulk.year
                                      ? itemsConvertBulk.year
                                      : '-'
                                  }}
                                </td>
                                <td class="f-12 black--text">
                                  {{
                                    budget.budgetOwner
                                      ? budget.budgetOwner
                                      : '-'
                                  }}
                                </td>
                                <td class="f-12 black--text">
                                  {{
                                    budget.taxonomyProtein
                                      ? budget.taxonomyProtein
                                      : '-'
                                  }}
                                </td>
                                <td>
                                  {{
                                    budget.taxoProteinDesc
                                      ? budget.taxoProteinDesc
                                      : '-'
                                  }}
                                </td>
                                <td class="text-right">
                                  {{ budget.amount ? idr(budget.amount) : '-' }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </template>
                    <hr class="hr-line mb-5 mt-5" style="" />
                  </v-col>
                </v-layout>
              </template>
            </v-card-text>
            <v-card-actions class="pa-0 pb-5 pr-5">
              <v-spacer></v-spacer>
              <v-btn
                :to="{ name: 'budgeting-report' }"
                class="grey darken-1 white--text"
                id="cancelBudget"
                >Cancel</v-btn
              >
              <v-btn
                type="submit"
                class="primary white--text"
                :disabled="isSave"
                id="saveBudget"
                >Save Budget</v-btn
              >
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogError" scrollable max-width="600px">
      <v-card class="py-3 pb-5">
        <v-flex class="text-center">
          <div
            class="swal2-icon swal2-error swal2-animate-error-icon"
            style="display: flex;"
          >
            <span class="swal2-x-mark">
              <span class="swal2-x-mark-line-left"></span>
              <span class="swal2-x-mark-line-right"></span>
            </span>
          </div>
          <h2 class="swal2-title" id="swal2-title">Failed!</h2>
          <p></p>
        </v-flex>
        <div class="swal2-content">
          <div id="swal2-content" style="display: block;">
            {{ budgetError.message }}
          </div>
        </div>
        <v-expansion-panels
          flat
          class="filterby-info mt-1"
          v-if="budgetError.dataError"
          v-model="panelListError"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-14 d-block text-center"
              height="100px"
            >
              {{ panelListError === 0 ? 'Hide' : 'Show' }} Error List
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text">
              <v-simple-table class="spending-table nav-table px-8 mt-5">
                <template v-slot:default>
                  <thead>
                    <tr class="primary custom-table-header">
                      <th class="f-14 font-weight-500">
                        Budget Owner
                      </th>
                      <th
                        class="f-14 font-weight-500"
                        v-if="budgetError.type === 'parse'"
                      >
                        Taxonomy
                      </th>
                      <th class="f-14 font-weight-500">Error</th>
                    </tr>
                  </thead>
                  <v-perfect-scroll
                    class="drawer-menu--scroll-error"
                    :settings="scrollSettingsError"
                  >
                    <tbody v-if="budgetError.dataError.length > 0">
                      <tr
                        v-for="(item, index) in budgetError.dataError"
                        :key="'bo' + index"
                      >
                        <td class="fs-12">
                          {{ item.budgetOwner }}
                        </td>
                        <td class="fs-12" v-if="budgetError.type === 'parse'">
                          {{ item.taxonomyProtein }}
                        </td>
                        <td class="fs-12">
                          {{ item.errorMessage }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="4" class="text-center pt-2">
                          <span>No Data Displayed</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-perfect-scroll>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="swal2-actions">
          <button
            type="button"
            class="swal2-confirm swal2-styled"
            style="display: inline-block; border-left-color: rgb(48, 133, 214); border-right-color: rgb(48, 133, 214);"
            @click="dialogError = false"
          >
            OK
          </button>
        </div>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import Swal from 'sweetalert2';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ACLMixin from '@/mixins/ACLMixin';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    vueDropzone: vue2Dropzone,
    VuePerfectScrollbar
  },
  mixins: [ACLMixin],
  data() {
    return {
      singleBO: true,
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsError: {
        maxScrollbarLength: 100
      },
      isDisabled: true,
      isDisabledBulk: true,
      loading: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        acceptedFiles: '.xlsx',
        maxFiles: 1,
        init: function() {
          this.on('addedfile', function() {
            if (this.files.length > 1) {
              this.removeFile(this.files[0]);
            }
          });
        },
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      },
      progressDialogLoading: false,
      search: '',
      isVisible: false,
      isVisibleBulk: false,
      isOwner: true,
      isBrand: true,
      isSave: true,
      fiscal: new Date().toISOString().substr(0, 7),
      items: {
        name: '',
        house: null,
        entity: null,
        brand: null,
        budget_owner: null
      },
      options: {},
      totalItems: 0,
      xlxFile: {},
      xlxFileBulk: {},
      nameFile: '',
      nameFileBulk: '',
      itemsEntity: [],
      itemsHouse: [],
      itemsBrand: [],
      itemsOwner: [],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      breadcrumbs: [
        {
          text: 'BUDGETING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'BUDGET REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'ADD (CHANGE) BUDGET',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Action', value: 'action' }
      ],
      brands: [],
      itemsConvert: [],
      itemsConvertBulk: [],
      dataBudget: {},
      baseUrl: process.env.VUE_APP_BASE_URL,
      dialogError: false,
      panelListError: null,
      budgetError: {
        message: '',
        dataError: []
      }
    };
  },
  mounted() {
    this.getHouse();
    this.getEntity();
    this.getBrand();
    this.getBudgetOwner();
  },
  methods: {
    getEntity() {
      this.$store
        .dispatch('budget/getEntity')
        .then(data => {
          if (data.code === 200) {
            this.itemsEntity = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getHouse() {
      let params = {
        paginate: false
      };
      this.$store
        .dispatch('budget/getHouse', params)
        .then(data => {
          if (data.code === 200) {
            this.itemsHouse = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getBrand() {
      let params = {
        paginate: false
      };
      this.$store
        .dispatch('budget/getBrand', params)
        .then(data => {
          if (data.code === 200) {
            this.itemsBrand = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getBudgetOwner() {
      this.progressDialogLoading = true;
      this.$store
        .dispatch('budget/getOwner')
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemsOwner = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    autoCompleteBudget() {
      if (this.items.budget_owner.mapping) {
        if (this.items.budget_owner.mapping.house) {
          this.items.house = this.items.budget_owner.mapping.house;
        } else {
          this.items.house = null;
        }
        if (this.items.budget_owner.mapping.entity) {
          this.items.entity = this.items.budget_owner.mapping.entity;
        } else {
          this.items.entity = null;
        }
        if (this.items.budget_owner.mapping.brand) {
          this.items.brand = this.items.budget_owner.mapping.brand;
        } else {
          this.items.brand = null;
        }
      } else {
        this.items.house = null;
        this.items.entity = null;
        this.items.brand = null;
      }
    },
    afterComplete(file) {
      this.isDisabled = false;
      this.xlxFile = file;
      this.nameFile = file.upload.filename;
    },
    afterCompleteBulk(file) {
      this.isDisabledBulk = false;
      this.xlxFileBulk = file;
      this.nameFileBulk = file.upload.filename;
    },
    parseFile(type) {
      var fileType =
        type === 'single'
          ? this.nameFile.split('.').pop()
          : this.nameFileBulk.split('.').pop();
      var fileTypes = ['xlsx', 'xls', 'XLS', 'XLSX'];
      let endpoint =
        type === 'single' ? 'budget/parse' : 'budgetDynamic/parseAddBudget';
      if (fileTypes.includes(fileType)) {
        this.progressDialogLoading = true;
        this.loading = true;
        this.isSave = false;
        let formData = new FormData();
        formData.append(
          'budget',
          type === 'single' ? this.xlxFile : this.xlxFileBulk
        );
        this.$store
          .dispatch(endpoint, formData)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              if (type === 'single') {
                this.itemsConvert = data.data;
                this.isDisabled = true;
                this.isVisible = true;
              } else {
                this.itemsConvertBulk = data.data;
                this.isDisabledBulk = true;
                this.isVisibleBulk = true;
              }
            } else {
              this.isSave = false;
              if (data) {
                this.dialogErrorParse('parse', data.response.data);
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
          });
      } else {
        Swal.fire('Failed!', 'Format file must be .xlsx', 'error');
        this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    dialogErrorParse(type, data) {
      this.budgetError.message = data.message.text_en;
      this.budgetError.type = type;
      if (data.data) {
        this.budgetError.dataError = data.data.datasError;
      } else {
        this.budgetError.dataError = [];
      }
      this.dialogError = true;
    },
    clear() {
      this.isVisible = false;
      this.isOwner = true;
      this.isBrand = true;
      this.isSave = true;
      this.items = {
        name: '',
        house: null,
        entity: null,
        brand: null,
        budget_owner: null
      };
      this.totalItems = 0;
      this.xlxFile = {};
      this.nameFile = '';
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    confirmSubmit() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to submit this budget?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.save();
        }
      });
    },
    save() {
      const validated = this.$refs.obs.validate();
      let dataObj = null;
      let endpoint = '';
      let payload = new FormData();
      if (this.singleBO) {
        dataObj = JSON.stringify({
          name: this.items.name,
          house_id: this.items.house.id,
          entity_id: this.items.entity.id,
          brand_id: this.items.brand.id,
          budget_owner_id: this.items.budget_owner.id,
          fiscal_month: parseInt(this.fiscal.slice(5, 7)),
          fiscal_year: parseInt(this.fiscal.slice(0, 4)),
          detail: this.itemsConvert
        });
        payload.append('file', this.xlxFile);
        payload.append('data', dataObj);
        endpoint = 'budget/create';
      } else {
        dataObj = {
          filename: this.nameFileBulk,
          month: this.itemsConvertBulk.month,
          year: this.itemsConvertBulk.year,
          data: this.itemsConvertBulk.data
        };
        payload = dataObj;
        endpoint = 'budgetDynamic/createBulk';
      }
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        this.$store
          .dispatch(endpoint, payload)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.clear();
              localStorage.setItem('fiscal_year', this.fiscal.slice(0, 4));
              this.$router.push({
                name: 'budgeting-report'
              });
            } else {
              if (data) {
                if (!this.singleBO) {
                  this.dialogErrorParse('submit', data.response.data);
                } else {
                  Swal.fire(
                    'Failed!',
                    data.response.data.message.text_en,
                    'error'
                  );
                }
              } else {
                Swal.fire('Failed!', 'Please Try Again', 'error');
              }
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    getTemplate(type) {
      let endpoint =
        type === 'single'
          ? '/v1/budgets/template?token='
          : '/v2/budget/template-bulk?token=';
      window.open(
        this.baseUrl + endpoint + localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style scoped lang="css">
.hr-line {
  margin-bottom: 10px;
  margin-top: 20px;
  border: 1px solid #d8d8d8;
}
.drawer-menu--scroll {
  height: 300px;
  overflow: auto;
}
.drawer-menu--scroll-error {
  max-height: 135px;
  overflow: auto;
}
</style>
